// extracted by mini-css-extract-plugin
module.exports = {"navWrapper":"NavLinks_mobiworkx_navWrapper__UeEHa","root":"NavLinks_mobiworkx_root__eWGQw","navLink":"NavLinks_mobiworkx_navLink__R4o6z"};